import styled from "styled-components";

export const CustomLabel = styled.label`
  width: 100%;
  font-family: "Nunito";
  font-size: ${({ fontSize }) => fontSize || "12px"};
  font-weight: ${({ fontWeight }) => fontWeight || "500"};
  margin-bottom: 0px;

  ${({ disabled }) =>
    disabled &&
    `
    color: #939799 !important;
    `}
`;

export const ErrorFeedback = styled.p`
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 500;
  color: red;
  margin-bottom: 0px;
`;
